import { CloseIcon } from "assets/icons";
import React from "react";
import styled, { css } from "styled-components";

type LabelColorVariant = "blue" | "red" | "grey";

interface LabelProps extends React.HTMLAttributes<HTMLDivElement> {
  onClickRemove?: () => void;
  variant: LabelColorVariant;
}

const Label = ({ children, onClickRemove, ...rest }: LabelProps) => {
  return (
    <LabelStyle {...rest}>
      {children}
      {onClickRemove && (
        <CloseButtonStyle onClick={onClickRemove}>
          <CloseIcon />
        </CloseButtonStyle>
      )}
    </LabelStyle>
  );
};

const LabelStyle = styled.div<LabelProps>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 0.2rem;
  flex-shrink: 0;

  padding: 0.4rem 1rem;
  border-radius: 0.4rem;

  ${({ theme }) => theme.typography.body2.regular};
  ${({ variant }) => cssLabelColor(variant)};

  ${({ theme }) => css`
    ${theme.media.small} {
      padding: 0.2rem 0.8rem;
      ${theme.typography.caption1.regular};
    }
  `}
`;

const CloseButtonStyle = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  svg {
    width: 1.6rem;
    height: 1.6rem;
    color: ${({ theme }) => theme.color.icon.tertiary};
  }
`;

const cssLabelColor = (variant: LabelColorVariant) => {
  switch (variant) {
    case "blue":
      return css`
        background-color: ${({ theme }) => theme.color.skyblue[100]};
        color: ${({ theme }) => theme.color.skyblue[700]};
      `;
    case "red":
      return css`
        background-color: ${({ theme }) => theme.color.brick[100]};
        color: ${({ theme }) => theme.color.brick[700]};
      `;

    case "grey":
      return css`
        background-color: ${({ theme }) => theme.color.grey[300]};
        color: ${({ theme }) => theme.color.grey[800]};
      `;
  }
};

export default Label;
